// extracted by mini-css-extract-plugin
export default {"chartCard":"ReportingView_chartCard__vv3Au","chartSub":"ReportingView_chartSub__Hrmft","note":"ReportingView_note__960L8"};